import React, { useMemo, useState } from "react";

/**
 * CareLogix™ ORACLE — Select Currency modal (Phase 22).
 *
 * Props:
 *   open: boolean
 *   instruments: [{ instrument, pair, ... }]
 *   selectedInstrument: string
 *   onSelect: (instrument) => void
 *   onClose: () => void
 */
export default function SelectCurrencyModal({
  open = false,
  instruments = [],
  selectedInstrument = "",
  onSelect,
  onClose,
} = {}) {
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    const term = q.trim().toUpperCase();
    if (!term) return instruments;
    return instruments.filter((it) => (it.pair || it.instrument || "").toUpperCase().includes(term));
  }, [q, instruments]);

  if (!open) return null;

  return (
    <div
      className="fx-modal"
      role="dialog"
      aria-modal="true"
      aria-label="Select Currency"
      data-testid="fx-select-currency-modal"
      onClick={(e) => { if (e.target === e.currentTarget) onClose && onClose(); }}
    >
      <div className="fx-modal__card">
        <header className="fx-modal__head">
          <strong>Select Currency</strong>
          <button
            type="button"
            className="fx-modal__close"
            onClick={onClose}
            aria-label="Close"
            data-testid="fx-select-currency-close"
          >×</button>
        </header>
        <div className="fx-modal__search">
          <input
            type="text"
            placeholder="Search pair…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            aria-label="Search currency pairs"
            data-testid="fx-select-currency-search"
          />
        </div>
        <ul className="fx-modal__list" role="listbox" aria-label="Currency pairs">
          {list.map((it) => {
            const sel = it.instrument === selectedInstrument;
            return (
              <li key={it.instrument}>
                <button
                  type="button"
                  role="option"
                  aria-selected={sel}
                  className={`fx-modal__row ${sel ? "is-selected" : ""}`}
                  onClick={() => onSelect && onSelect(it.instrument)}
                  data-testid={`fx-select-currency-row-${it.instrument}`}
                >
                  <span className={`fx-modal__radio ${sel ? "is-on" : ""}`} aria-hidden="true" />
                  <span className="fx-modal__pair">{it.pair || it.instrument}</span>
                </button>
              </li>
            );
          })}
          {list.length === 0 && <li className="fx-modal__empty">No pairs match.</li>}
        </ul>
      </div>
    </div>
  );
}
